module.exports = __webpack_public_path__ + "media/images/stripe/light-on-dark-6d59d9c82ef8a52f90fcda8f87233a2e.png";